export const PaymentType = {
    'credit': 'Credit',
    'debit': 'Debit',
    'hold': 'Hold'
}
